<template>
      <div class="tab-wrap">
        <ul class="child-tab" ref="childTabSet" :class="[childTabIsFixed? 'isFixed':'']" >
            <li
            :class="[currentIndex===i? 'active':'']"
            v-for="(v,i) in childrenTabData"
            :key="i"
            @click="scrollTo(i)"
          >{{v}}</li>
<!--          >{{v}}{{childTabOffsetData[i]}}</li>-->
        </ul>
      </div>
</template>

<script>
export default {
  props: {
    childrenTabData: {
      type: Array,
      default: () => {
        return []
      }
    },
    childTabOffsetData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      offsetTopData: 0,
      currentIndex: 0,
      childTabIsFixed: false
    }
  },
  methods: {
    scrollTo (i) {
      // this.currentIndex = i
      this.$nextTick(() => {
        // 循环优化代码
        this.childTabOffsetData.forEach((v, ii) => {
          if (i === ii) {
            const height = this.$refs.childTabSet.offsetHeight
            window.scrollTo({
              top: v + height,
              behavior: 'smooth'
            })
          }
        })
      })
    },
    handleScroll () {
      // 监听浏览器窗口距离页面顶部的距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // 判断滚动是否触顶,粘连导航栏
      if (scrollTop > this.offsetTopData - 120) {
        this.childTabIsFixed = true
      } else {
        this.childTabIsFixed = false
      }
      // 判断滚动的位置，动态切换tab栏，循环优化代码
      const c = JSON.parse(JSON.stringify(this.childTabOffsetData))
      // +100是将标题往下挪动出现的距离+100，优化体验
      c.forEach((v, i) => {
        if (i === 0) {
          if (scrollTop > 0 && scrollTop < c[i + 1] - 100) {
            this.currentIndex = i
          }
        } else if (i === c.length - 1) {
          if (scrollTop > c[i] - 100) {
            this.currentIndex = i
          }
        } else {
          if (scrollTop > c[i] - 100 && scrollTop < c[i + 1] - 100) {
            this.currentIndex = i
          }
        }
      })
      // if (scrollTop > 0 && scrollTop < this.childTabOffsetData[1] - 100) {
      //   this.currentIndex = 0
      // }
      // if (scrollTop > this.childTabOffsetData[1] - 100 && scrollTop < this.childTabOffsetData[2] - 100) {
      //   this.currentIndex = 1
      // }
      // if (scrollTop > this.childTabOffsetData[2] - 100 && scrollTop < this.childTabOffsetData[3] - 100) {
      //   this.currentIndex = 2
      // }
      // if (scrollTop > this.childTabOffsetData[3] - 100 && scrollTop < this.childTabOffsetData[4] - 100) {
      //   this.currentIndex = 3
      // }
      // if (scrollTop > this.childTabOffsetData[4] - 100) {
      //   this.currentIndex = 4
      // }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    // 监听元素距离页面顶部的距离   +100是需要算上主题导航栏的100高度
    this.offsetTopData = this.$refs.childTabSet.offsetTop + 100
  }
}
</script>

<style lang='scss' scoped>
        .tab-wrap{
            width: 100%;
            // height: 60px;
            box-sizing: border-box;
            // padding: 20px;
        }
        .child-tab {
            padding: 20px;
            width: 100%;
            background-color: #ffffffcc;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            backdrop-filter: blur(2px);
            overflow-x: auto;
            li {
                font-size: 16px;
                color: #1c1c1c;
                margin-right: 30px;
                cursor: pointer;
                white-space: nowrap;
            }
            .active {
                font-weight: bold;
                color: #3563F8;
            }
        }
        .isFixed{
            position:fixed;
            top:0;
            z-index: 9;
        }
</style>
